export const hourFormatter = (params) => {
  const value = params.value / 3600;
  const hours = Math.floor(value);
  const minutes = Math.round((value - hours) * 60);

  return `${hours > 0 ? hours + 'h' : ''}${minutes > 0 ? minutes + 'min' : ''}`;
};

export default {
  hourFormatter
};